import { RemoteGetByIdProfessionalManagement } from 'data/usecases/professionals';
import { GetByIdProfessionalManagementUseCaseInterface } from 'domain/usecases';
import { makeApiUrlProfessionalsManager } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetByIdProfessionalManagement =
  (): GetByIdProfessionalManagementUseCaseInterface =>
    new RemoteGetByIdProfessionalManagement(
      makeApiUrlProfessionalsManager(),
      makeAxiosHttpClient(),
    );
